import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from '@/vuex-decorators';
import { Resource } from './data/resource.interface';
import { productResources, videoLibrary } from './data/resources';

@Component
export default class Super extends Vue {
  readonly mobile = true;

  @Mutation
  openWeb(title: string, url: string) { return { title, url }; };

  @Mutation
  openLargeWeb(title: string, url: string) { return { title, url }; };

  @Mutation
  openResourceList(resources: Resource[], title: string) { return { resources, title }; };

  @Mutation
  openPDF(title: string, url: string) { return { title, url }; };

  @Mutation
  openVideo(title: string, url: string) { return { title, url }; };

  openChallenge() {
    this.openLargeWeb('The Expert Challenge', './challenge/index.html');
  }
  goBack() {
    window.location.href ="https://sunovionexhibitbooth.com/psych/";
  }

  openProductResources() {
    this.openResourceList([...productResources], 'Product Resources');
  }

  openVideoLibrary() {
    this.openResourceList([...videoLibrary], 'Video Library');
  }
}
